import React from "react"
import Button from "aldoo-ra/Button"
import useT from "../../hooks/useT"
import { useCategories } from "../../hooks/useCatalogData"

/**
 * The categories and series whose name contains the search text — what a
 * search finds besides products. Each is a link to its page, labelled with
 * what it is: "Малък сръчко · Поредица", "Трилъри · Категория".
 */
const norm = (value) => String(value || "").trim().toLowerCase()

/** The matching terms of a list, categories first, at most `limit`. */
export function matchTerms(list, text, limit = 6) {
  const needle = norm(text)
  if (needle.length < 2) return []
  const matches = (list || []).filter((term) => term.enabled !== false && norm(term.name).includes(needle))
  // a name that starts with the text comes before one that merely contains it
  matches.sort((a, b) => Number(norm(b.name).startsWith(needle)) - Number(norm(a.name).startsWith(needle)) || (a.kind === "series") - (b.kind === "series"))
  return matches.slice(0, limit)
}

export function useTermMatches(text, limit) {
  const { list } = useCategories()
  return matchTerms(list, text, limit)
}

export const kindLabel = (t, kind) => (kind === "series" ? t`Series` : t`Category`)

/** The matches as rows (the search results page). Nothing when there are none. */
export default function TermMatches({ text, className = "" }) {
  const t = useT()
  const terms = useTermMatches(text)
  if (!terms.length) return null
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid="term-matches">
      {terms.map((term) => (
        <Button variant="none"
          key={term.categoryId}
          href={`/category/${term.categoryId}`}
          className="inline-flex items-baseline gap-2 rounded-full border border-bordered bg-paper px-4 py-2 text-[15px] hover:border-primary hover:text-primary"
        >
          <span className="font-medium">{term.name}</span>
          <span className="text-[12px] uppercase tracking-wide text-text_secondary">{kindLabel(t, term.kind)}</span>
        </Button>
      ))}
    </div>
  )
}
